<template>
    <v-container>
        <v-layout wrap justify-center align-center>
            <v-flex xs12>
                <v-form
                        v-model="valid"
                        class="login-form"
                        row
                        justify-center>

                    <v-card class="mx-auto" max-width="500" color="transparent" flat>
                        <v-alert type="info" color="primary"  :value="true" class="text-center" style="border-radius: 8px">
                            Antes de continuar, necesitamos verificar tu identidad:
                        </v-alert>
                    </v-card>

                    <v-card color="white darken-3" class="kim-card form-wrapper mx-auto pt-2 px-2" max-width="500">

                        <v-card-text class="px-4 text-center">
                            <v-text-field
                                    @keydown.enter.prevent="login"
                                    :readonly="loadingLogin"
                                    :clearable="!loadingLogin"
                                    :rules="passwordRules"
                                    label="RUT"
                                    :maxlength="12"
                                    hide-details
                                    :value="dni | rut"
                                    @input="value => dni = value.replace(/(\.|\-)/g, '')"
                                    placeholder="Ingresa tu RUT"
                                    :type="showPassword ? 'text' : 'password'"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    @click:append="showPassword = !showPassword"
                                    class="mt-2 mb-4 px-4"
                                    required
                            ></v-text-field>

                            <v-btn
                                    rounded
                                    class="mx-auto my-1"
                                    :loading="loadingLogin || firstLoadingLogin"
                                    color="primary"
                                    @click="login"
                                    style="width: 80%"
                            >Confirmar</v-btn>
                        </v-card-text>

                    </v-card>

                </v-form>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        name: 'LoginDialog',
        components: {},
        props: {
            autoLogin: {
                type: Boolean,
                default: false
            }
        },
        async mounted(){
            var vm = this
                const credentials = await ApiUtils.getUserCredentials()
                if(credentials && credentials.dni){
                    vm.dni = credentials.dni
                    vm.valid = true
                    if(vm.autoLogin === true){
                        vm.$nextTick(function(){
                            vm.login()
                        })
                    }
                }

        },
        data(){
            return {
                showSpecialistSignUp: false,
                valid: false,
                disabled: false,
                email: '',
                dni: '',
                showPassword: true,
                passwordRules: [
                    v => !!v || 'RUT es obligatorio',
                    v => v.length >= 8 || 'Debe tener al menos 8 caracteres'
                ],
            }
        },
        computed: {
            ...mapState(['currentUser', 'loginMessage', 'loadingLogin', 'firstLoadingLogin'])
        },
        methods: {
            ...mapMutations(['showSnackBar', 'setLoginLoading']),
            async login(){

                var vm = this
                if(!vm.valid)   {
                    vm.showSnackBar('Datos incorrectos', 'secondary')
                    return
                }

                vm.disabled = true
                const response = await ApiUtils.clientLogin(vm.dni, true)
                vm.disabled = false

                if (response.code == 401) {
                    vm.showSnackBar('Acceso denegado', 'secondary')
                    return
                }

                vm.$emit('success', response)

            }
        },
        watch:{
            loadingLogin(val){
                var vm = this
                if(!val && !!vm.currentUser){
                    vm.$emit('success')
                }
            },
            firstLoadingLogin(val){
                var vm = this
                if(!val && !!vm.currentUser){
                    vm.$emit('success')
                }
            }
        }
    }

</script>

<style >

    .form-wrapper{
        border-radius: 10px;
    }

    .login-form input:-webkit-autofill,
    .login-form input:-webkit-autofill:hover,
    .login-form input:-webkit-autofill:focus,
    .login-form input:-webkit-autofill:active  {
        -webkit-box-shadow: 0 0 0 30px rgba(0,0,0,0) inset !important;
    }

    .login-form input:-webkit-autofill {
        -webkit-text-fill-color: #000000 !important;
    }

    @-webkit-keyframes autofill {
        to {
            color: #000000;
            background: transparent;
        }
    }

    .login-form input:-webkit-autofill {
        -webkit-animation-name: autofill;
        -webkit-animation-fill-mode: both;
    }
</style>
